import React from 'react';
import TopicLevelOneTable from './TopicLevelOneTable';
import { LanguageType } from '@op/types/common';
// import { clickTopicToFeedsWithTab } from '@op/utils/url';
// import { useHistory } from 'umi';
import './index.scss';
import useDealwithTopic from '@op/pages/Summary/hooks/useDealwithTopic';
export default function TopicPerformanceTable({
  topicLevelList,
  language,
  loading,
  filter,
  // gameInfo,
  topicTitleEn,
  topicTitleCn,
  icon,
  sentimentType,
  filterCond,
}: {
  topicLevelList: any;
  language: LanguageType;
  loading: boolean;
  filter: any;
  gameInfo: any;
  topicTitleEn: string;
  topicTitleCn: string;
  icon: string;
  sentimentType: string;
  filterCond: any;
}) {

  // const history = useHistory();
  // const goToFeeds = (topic: string, topicLevel: 'L1' | 'L2' = 'L2') => {
  //   let topics: any = [topic];
  //   if (topicLevel === 'L1') {
  //     topics = topicTree[topic];
  //   }
  //   clickTopicToFeedsWithTab({
  //     filter: { ...filter, topic: topics },
  //     gameInfo,
  //     history,
  //   });
  // };

  const { transTopic } = useDealwithTopic({ condTopicList: filterCond?.topic_trans });

  return (
    <TopicLevelOneTable
      topicLevelList={topicLevelList}
      filter={filter}
      transTopic={transTopic}
      language={language}
      loading={loading}
      // goToFeeds={goToFeeds}
      topicTitleEn={topicTitleEn}
      topicTitleCn={topicTitleCn}
      icon={icon}
      sentimentType={sentimentType}
    ></TopicLevelOneTable>
  );
}
